<template>
  <div class="Policy-main" ref="Policy-main" :class="{ 'Policy-main-mobile': isMobile }">
    <Base-title :title="company.name"></Base-title>
    <div class="Policy-content" v-html="company.html"></div>
  </div>
</template>
<script>
  export default {
    name: 'document',
    data() {
      return {
        company: {
          name: '关联方清单',
          html: `
          <div>
            <table border="1px solid #ccc" cellspacing="0" cellpadding="0" style="font-size:14px;" id="table-7">
              <tr>
                <th>公司名称</th>  
                <th>注册地址</th>  
              </tr>
              <tr>
                <td>贝壳找房（北京）科技有限公司</td>  
                <td>北京市海淀区创业路2号1幢1层102室</td>  
              </tr>
              <tr>
                <td>北京理房通支付科技有限公司</td>  
                <td>北京市海淀区创业路2号1幢3层301室</td>  
              </tr>
              <tr>
                <td>北京安理保险经纪有限公司</td>  
                <td>北京市密云区新南路43号院1号楼(四层416室)</td>  
              </tr>
              <tr>
                <td>北京链家房地产经纪有限公司</td>  
                <td>北京市朝阳区将台路5号院16号楼601室</td>  
              </tr>
              <tr>
                <td>北京链家置地房地产经纪有限公司</td>  
                <td>北京市朝阳区酒仙桥东路9号院1号楼5层</td>  
              </tr>
              <tr>
                <td>北京链家高策房地产经纪有限公司</td>  
                <td>北京市密云区中关村密云园康宝路12号A座办公楼-11</td>
              </tr>
              <tr>
                <td>贝壳找房网（北京）信息技术有限公司</td>  
                <td>北京市密云区经济开发区兴盛南路8号开发区办公楼501室-1834</td>  
              </tr>
              <tr>
                <td>天津屋客网络科技有限公司</td>  
                <td>天津开发区南海路12号A3栋708室</td>  
              </tr>
              <tr>
                <td>天津小屋信息科技有限公司</td>  
                <td>天津开发区南海路12号A3栋708室</td>  
              </tr>
              <tr>
                <td>圣都家居装饰有限公司</td>  
                <td>浙江省杭州市拱墅区石祥路589号</td>  
              </tr>
              <tr>
                <td>北京被窝装饰有限公司</td>  
                <td>北京市密云区水源路南侧A-04地块2#商业办公楼6层1单元-618号（南侧）</td>
              </tr>
              <tr>
                <td>贝壳技术有限公司</td>  
                <td>天津开发区南海路12号A3栋708室</td>  
              </tr>
              <tr>
                <td>贝塔通科技（北京）有限公司</td>  
                <td>北京市海淀区永澄北路2号院1号楼1层2649号</td>
              </tr>
            </table>  
          </div>
`
        }
      };
    },
    created() {}
  };
</script>
<style scoped lang="scss">
  .Policy-main {
    position: relative;
    display: flex;
    align-items: center;
    overflow: hidden;
    padding: calc($multiple * 78px) 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: #f6faff;
    flex-direction: column;
    overflow: auto;
    .Policy-content {
      margin-top: calc($multiple * 72px);
      width: 100%;
      display: flex;
      justify-content: center;
      position: relative;
      width: calc($multiple * 1123px);
    }
  }
  .Policy-main-mobile {
    padding: 2.1rem 0 1.54rem;
    height: initial;
    .Policy-content {
      margin-top: 1.43rem;
      width: 17.15rem;
      flex-direction: column;
      font-size: 0.61rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.84);
      line-height: 0.98rem;
      letter-spacing: 0.05rem;
      text-align: justify;
      word-break: break-all;
    }
  }
  /* Table Head */
  ::v-deep #table-7 th {
    background-color: #0b70ff !important;
    color: #fff;
    border-bottom-width: 0;
  }

  /* Column Style */
  ::v-deep #table-7 td {
    color: #000;
  }
  /* Heading and Column Style */
  ::v-deep #table-7 tr,
  ::v-deep #table-7 th {
    border-width: 1px;
    border-style: solid;
    border-color: rgb(81, 130, 187);
  }

  /* Padding and font style */
  ::v-deep #table-7 td,
  ::v-deep #table-7 th {
    padding: 5px 10px;
    font-family: Verdana;
    font-weight: bold;
  }
</style>
